import { render } from "./DuaPage.vue?vue&type=template&id=5a7dc777&scoped=true"
const script = {}

import "./DuaPage.vue?vue&type=style&index=0&id=5a7dc777&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7dc777"]])

export default __exports__